
import { Component, Vue } from 'vue-property-decorator';

import FormModule from '@/store/modules/form';
import { getGenderSelectorItems, getStateSelectorItems } from '@/utils/global.util';

@Component({})
export default class FreeSubsForm extends Vue {
  formStores: FormStore[];
  formModel: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    city: string;
    state: string;
    zip: number | null;
    store: string;
    gender: string;
    birthDate: Date | null;
    testFile: any;
    testFileTwo: any;
    hasAcceptedEmailNotifications: boolean;
    hasAcceptedRules: boolean;
  };

  data() {
    return {
      formStores: null,
      formModel: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        city: '',
        state: '',
        zip: null,
        store: '',
        gender: '',
        testFile: null,
        testFileTwo: null,
        birthDate: null,
        hasAcceptedEmailNotifications: true,
        hasAcceptedRules: false,
      }
    }
  }

  async mounted() {
    const stores = await FormModule.getFormStores();
    this.formStores = stores;
  }

  get redirectUrl() {
    return window?.__INITIAL_STATE__?.thankYouUrl;
  }

  get states() {
    return getStateSelectorItems();
  }

  get genders() {
    return getGenderSelectorItems();
  }

  get stores() {
    const stores = this.formStores;
    const results: SelectorItem[] = [];

    if (!stores) {
      return;
    }

    results.push({
      value: '',
      id: '',
      label: ''
    });

    stores.forEach((formStore) => {
      results.push({
        value: formStore.storeNumber,
        id: formStore.storeNumber,
        label: formStore.name
      });
    });

    return results;
  }

  async submitHandler(formModel) {
    const loader = this.$loading.show();
    try {
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('freesubs');

      let { freeSubsSlug } = this.$route.params;
      if (!freeSubsSlug) {
        freeSubsSlug = 'free-subs-default-campaign';
      }

      await FormModule.submitFreeSubs({ ...formModel, recaptchaToken: token, slug: freeSubsSlug } as FreeSubsRequest)
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl
      } else {
        this.$toasted.success('Your submission has been received!');
        this.formModel = {
          ...formModel,
          hasAcceptedEmailNotifications: true,
          hasAcceptedRules: false
        };
      }
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      loader.hide();
    }
  }
}
